import { returnParseProjectElement } from "./project.controller";

export const getPrice = (price: number | string) => {
  let CURRENCY_CODE = returnParseProjectElement('CURRENCY_CODE')

  return Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY_CODE }).format(Number(price))
}